import { Link } from "react-router-dom";

const SOLUTIONS = [
  { to: "/roll-press", label: "Roll Press Solution" },
  { to: "/servo-hydraulic", label: "Servo Hydraulic" },
  { to: "/engineering", label: "Engineering Service" },
];

const PRODUCTS = [
  { to: "/products#servo-valves", label: "Servo Valves" },
  { to: "/products#drives-motors", label: "Servo Drives & Motors" },
  { to: "/products#motion", label: "Motion Controllers" },
  { to: "/products#sensors", label: "Sensors" },
  { to: "/products#hydraulic", label: "Hydraulic Components" },
];

const COMPANY_LINKS = [
  { to: "/company", label: "About MC TECH" },
  { to: "/engineering", label: "Engineering" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-10">
          {/* Brand + Info */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-md flex items-center justify-center font-heading font-bold text-base bg-primary-700 text-background-50">
                MC
              </span>
              <div className="flex flex-col leading-tight">
                <span className="font-heading font-extrabold text-lg text-primary-800">
                  MC TECH
                </span>
                <span className="text-[10px] font-medium tracking-[0.15em] uppercase text-secondary-600">
                  Roll Press Engineering
                </span>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              Roll Press 장비의 정밀 압력·위치·갭 제어를 위한 서보유압 및
              모션제어 솔루션을 제공합니다. MOOG 제품 공급부터 회로 검토, 제어
              프로그램, 현장 시운전까지 지원합니다.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="text-[11px] font-semibold tracking-wide px-2.5 py-1 rounded-md bg-accent-100 text-accent-900">
                Servo Hydraulic
              </span>
              <span className="text-[11px] font-semibold tracking-wide px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900">
                Motion Control
              </span>
              <span className="text-[11px] font-semibold tracking-wide px-2.5 py-1 rounded-md bg-primary-100 text-primary-800">
                MOOG Partner
              </span>
            </div>

            {/* Company Info */}
            <div className="mt-7 pt-6 border-t border-background-200 space-y-2.5 text-sm">
              <div className="flex items-start gap-2.5">
                <span className="text-secondary-500 font-medium shrink-0 w-[72px]">회사명</span>
                <span className="text-foreground-800 font-semibold">MC Tech</span>
              </div>
              <div className="flex items-start gap-2.5">
                <span className="text-secondary-500 font-medium shrink-0 w-[72px]">대표자</span>
                <span className="text-foreground-800 font-semibold">전만중</span>
              </div>
              <div className="flex items-start gap-2.5">
                <span className="text-secondary-500 font-medium shrink-0 w-[72px]">주소</span>
                <span className="text-foreground-800 leading-snug">
                  경기도 용인시 기흥구 흥덕중앙로 120 1209호
                </span>
              </div>
              <div className="flex items-start gap-2.5">
                <span className="text-secondary-500 font-medium shrink-0 w-[72px]">대표전화</span>
                <a
                  href="tel:031-736-3275"
                  className="text-foreground-800 font-semibold hover:text-primary-700 cursor-pointer whitespace-nowrap"
                >
                  031-736-3275
                </a>
              </div>
              <div className="flex items-start gap-2.5">
                <span className="text-secondary-500 font-medium shrink-0 w-[72px]">이메일</span>
                <a
                  href="mailto:motion@imctech.co.kr"
                  className="text-foreground-800 font-semibold hover:text-primary-700 cursor-pointer whitespace-nowrap"
                >
                  motion@imctech.co.kr
                </a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              Solutions
            </h4>
            <ul className="space-y-2.5">
              {SOLUTIONS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer whitespace-nowrap"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              Products
            </h4>
            <ul className="space-y-2.5">
              {PRODUCTS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer whitespace-nowrap"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              Company
            </h4>
            <ul className="space-y-2.5">
              {COMPANY_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer whitespace-nowrap"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-4">
              <Link
                to="#"
                className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer whitespace-nowrap"
              >
                개인정보처리방침
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-secondary-600">
            Copyright © MC TECH. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-600">
            <span className="whitespace-nowrap">
              Roll Press · Servo Hydraulic · Motion Control · MOOG Partner
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}